﻿<rdo-overlay [enabled]="loading"></rdo-overlay>
<ng-container *featureFlag="'flagSavedViews'">
  <rdo-saved-views
    [gridName]="gridName"
            [pageName]="
            translateService.instant('main.tabs.customers.customers')
          "
    />
</ng-container>
@if (selectedProductTypeService.isProductSelected && data && totalCount > 0) {
  <rdo-grid-table-expanded-ng
    #customersGrid
    [name]="gridName"
    [dataKey]="dataKey"
    [gridConfig]="gridConfig()"
    [rowExpansion]="gridConfig().rowExpansion"
    [pagedData]="data"
    [frozenRows]="frozenRows"
    [sorting]="sorting"
    [(paging)]="paging"
    (pageOnChange)="changePage($event)"
    (lazyLoadOnChange)="changeLazyLoad($event)"
    [totalCount]="totalCount"
    [frozenWidth]="frozenWidth"
    [showColumnSelector]="true"
    [scrollScale]="'smallScale'"
    (downloadExcelClick)="exportExcel($event)"
    [alwaysShowPager]="false"
    />
}
@if (!selectedProductTypeService.isProductSelected || totalCount === 0) {
  <div class="no-data-available">
    {{'main.tabs.equipment.product_types.no_data_available' | translate}}
  </div>
}
